(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dst-coffee-look"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dst-shop-look')) {
  customElements.define('dst-shop-look', class extends HTMLElement {
    connectedCallback() {
      if (this.filterHandler) return;
      this.select = this.querySelector('[data-extra-filter]');
      if (!this.select) return;
      this.cards = Array.from(this.querySelectorAll('[data-look-extra]'));
      Array.from(this.select.options).forEach(option => {
        if (option.value !== 'all' && !this.cards.some(card => card.dataset.category === option.value)) option.remove();
      });
      this.filterHandler = () => {
        const category = this.select.value;
        let count = 0;
        this.cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) count++;
        });
        this.querySelector('[data-extra-count]').textContent = count + ' ' + this.dataset.countLabel;
        this.querySelector('[data-extra-empty]').hidden = count !== 0;
      };
      this.select.addEventListener('change', this.filterHandler);
      this.filterHandler();
    }
    disconnectedCallback() {
      if (this.select && this.filterHandler) this.select.removeEventListener('change', this.filterHandler);
      this.filterHandler = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dst-look-standard"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dst-shop-look')) {
  customElements.define('dst-shop-look', class extends HTMLElement {
    connectedCallback() {
      if (this.filterHandler) return;
      this.select = this.querySelector('[data-extra-filter]');
      if (!this.select) return;
      this.cards = Array.from(this.querySelectorAll('[data-look-extra]'));
      Array.from(this.select.options).forEach(option => {
        if (option.value !== 'all' && !this.cards.some(card => card.dataset.category === option.value)) option.remove();
      });
      this.filterHandler = () => {
        const category = this.select.value;
        let count = 0;
        this.cards.forEach(card => {
          card.hidden = category !== 'all' && card.dataset.category !== category;
          if (!card.hidden) count++;
        });
        this.querySelector('[data-extra-count]').textContent = count + ' ' + this.dataset.countLabel;
        this.querySelector('[data-extra-empty]').hidden = count !== 0;
      };
      this.select.addEventListener('change', this.filterHandler);
      this.filterHandler();
    }
    disconnectedCallback() {
      if (this.select && this.filterHandler) this.select.removeEventListener('change', this.filterHandler);
      this.filterHandler = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
